import dynamic from 'next/dynamic';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import A from './components/A';
import Z1 from './components/Z1';
import Z1_AU from './components/Z1_AU';
import J1 from './components/J1';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';

const Dynamic = dynamic(() => import('./indexDynamic'), { ssr: true });
const DynamicEU = dynamic(() => import('./indexDynamicEU'), { ssr: true });
const DynamicAU = dynamic(() => import('./indexDynamicAU'), { ssr: true });
export default function Teaser() {
    const { useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined' && typeof ScrollMagic == 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    useEffect(() => {
        return () => {
            AniContainer?.destroy();
        };
    }, []);

    return (
        <div className={`delta-2-max-teaser ${css.delta2MaxTeaser}`}>
            {/* 北美版本 */}
            {['us', 'ca', 'za'].includes(locale) && (
                <>
                    <A />
                    <Dynamic />
                </>
            )}
            {/* 欧洲版本 */}
            {['eu', 'uk', 'de', 'fr', 'it', 'es', 'cn'].includes(locale) && (
                <>
                    <Z1 stage={'teaser'} />
                    <DynamicEU stage={'teaser'} />
                </>
            )}
            {/* 日本版本 */}
            {['jp'].includes(locale) && (
                <>
                    <J1 stage={'teaser'} />
                </>
            )}
            {/* 澳洲版本 */}
            {['au'].includes(locale) && (
                <>
                    <Z1_AU stage={'teaser'} />
                    <DynamicAU stage={'teaser'} />
                </>
            )}
        </div>
    );
}
